import { useIntl } from "react-intl";

import { FormErrors, SubmitFunction } from "@nens/ranalib";

import { useEditPublication } from "../../../api/edit";
import { PublicationFormValues } from "../create";

export function usePublicationEditModal({
  onSuccess,
  publicationId,
}: {
  onSuccess: () => void;
  publicationId: string;
}) {
  const intl = useIntl();

  const { isMutating, mutate } = useEditPublication();

  const validate = (values: PublicationFormValues) => {
    const errors: FormErrors = {};
    if (!values.name) {
      errors.name = intl.formatMessage({
        id: "form.required.name",
        defaultMessage: "Name is required",
      });
    }

    return errors;
  };

  // Submit can assume validate returned no errors.
  const submit: SubmitFunction<PublicationFormValues> = (values, onError) => {
    const name: string = values.name + "";
    const description: string = (values.description ?? "") + "";

    const publicationUpdate = {
      name,
      description,
    };

    mutate(
      { publicationId, publicationUpdate },
      {
        onSuccess,
        onError,
      }
    );
  };

  return { validate, submit, isMutating };
}
